import { useSyncExternalStore } from 'react';

// On routes whose sidebar morphs into something else (/ai → Chats), the
// header ☰ opens the regular app nav as an overlay instead of toggling the
// sidebar. Module store so the header and the overlay share it without a
// provider in the shell.
let open = false;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach((l) => l());
}

export function setAppNavOverlayOpen(next: boolean): void {
  if (open === next) return;
  open = next;
  emit();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useAppNavOverlayOpen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => open,
    () => false
  );
}
